export const formatNumber = (num: number, template: string) => {
  const provider = [...`${num} `].reverse()
  return [...template].reduce((a, b, i, n) => a + (b === '*' ? provider.pop() : b), '')
}
